import { gql } from '@apollo/client';

export const INSERT_FAVORITES = gql`
  mutation insertFavourites($jwMediaId: String!) {
    insertFavourites(jwMediaId: $jwMediaId) {
      message
    }
  }
`;

export const DELETE_FAVORITES = gql`
  mutation deleteFavourites($jwMediaId: String!) {
    deleteFavourites(jwMediaId: $jwMediaId) {
      message
    }
  }
`;

export type FavoriteResponse = {
  message: string;
};

export type InsertFavoritesData = {
  insertFavourites: FavoriteResponse;
};

export type DeleteFavoritesData = {
  deleteFavourites: FavoriteResponse;
};
